<div class="EmptyClasslayer"> </div>
    <div class="d-flex gap-4 align-items-center" style="position: relative; z-index: 11111111; background: #fff;
    padding: 10px;">
      <ng-select
      *ngIf="item?.isOpenedLookup"
      [items]="filteredOptions[column.name]"
      bindLabel="value"
      appendTo="#{{ column.name }}"
      #in
      [ngModelOptions]="{ standalone: true }"
      [id]="column.name"
      placeholder="{{ column.label }}"
      [maxSelectedItems]="!column.allowMultipleValues ? 1 : undefined"
      [multiple]="true"
      placeholder="{{ column.label }}"
      (keyup)="dynamicSearch($event, column)"
      clearable="true"
      class="ng-select-latest"
      style="width: 100%; min-width: 150px;"
      [ngClass]="{
            'single-select':
              column.allowMultipleValues == null ||
              column.allowMultipleValues == false
          }"
      [(ngModel)]="filedValueLookup"
      bindValue="id"
    >
      <ng-template ng-footer-tmp>
        <div *ngIf="loadingAPI" [nbSpinner]="true" nbSpinnerStatus="info">
          Loading ...
        </div>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <div
          [ngbPopover]="templateRef5"
          placement="bottom"
          container="body"
          #editNotLoadAsDropdownLookupPopover="ngbPopover"
          [autoClose]="'outside'"
        >
          <i class="fa fa-window-close" (click)="removeSelected(item)">x</i>
          <b style="font-size: 16px" [innerHTML]="item.value | renderImage"></b>
        </div>
      </ng-template>
    </ng-select>
    <div  style="display: inline-block; margin-left: 20px; margin-right: 20px;"  (click)="SaveDataFunciton()"><i class="fa fa-check" aria-hidden="true"></i></div>
    <div  style="display: inline-block;     width: 29px;"  (click)="closeFun()"><i class="fa fa-times" aria-hidden="true"></i></div>

    </div>
